import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=21aad234&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"
import style0 from "./sso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports